import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MarketingLandingPage from './components/MarketingLandingPage';
import LandingPage from './components/LandingPage';
import ResidentList from './components/ResidentList';
import ResidentDetail from './components/ResidentDetail';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MarketingLandingPage />} />
        {/* /dashboard now redirects to /residents (Resident Stats) */}
        <Route path="/dashboard" element={<Navigate to="/residents" replace />} />
        <Route path="/department" element={<LandingPage />} />
        <Route path="/residents" element={<ResidentList />} />
        <Route path="/resident/:id" element={<ResidentDetail />} />
      </Routes>
    </Router>
  );
}

export default App;
